<template>
    <div :id="id" class="h-full w-full"></div>
</template>

<script>
//Need this is a module scope so that it can be accessed in the "setup" scope by defineProps for initialization of variables
//SECLOCK Address
const seclock_default_location = {
    lat: 42.204383,
    lng: -71.150976,
};
export default {};
</script>

<script setup>
import { watch, onMounted } from "vue";
import { useGoogleMapsApi } from "@/Composables";

const { bind_autocomplete, code_address, code_markers } = useGoogleMapsApi();

const props = defineProps({
    id: {
        type: String,
        required: true,
    },

    //NOTE: If markers are provided an option with "center" must be specified
    markers: {
        type: Object,
        required: false,
        default: {
            //SECLOCK address
            ma: {
                lat: seclock_default_location.lat,
                lng: seclock_default_location.lng,
                title: "SECLOCK",
                info: "SECLOCK",
            },
        },
    },
    options: {
        type: Object,
        required: false,
        default: {
            /* The remainder of the default options are defined in the Composable useGoogleMapApi */
            center: {
                lat: seclock_default_location.lat,
                lng: seclock_default_location.lng,
            },
        },
    },
    address: {
        type: Object,
        required: false,
        default: {},
    },
});

onMounted(() => {
    //Map address OR markers
    if (Object.keys(props.address).length) {
        code_address(props.id, props.address);
    } else if (Object.keys(props.markers).length) {
        code_markers(props.id, props.markers, props.options);
    }
});

watch(
    () => props.address,
    (new_address) => code_address(props.id, new_address)
);

watch(
    () => props.markers,
    (new_markers) => code_markers(props.id, new_markers, props.options)
);
</script>
